<template>
  <div class="weiVCon videoD">
    <div class="trainListBox">
      <mt-navbar
        v-model="selected"
        fixed
      >
        <mt-tab-item id="taxi_2">客运</mt-tab-item>
        <mt-tab-item id="goodsCar_1">货运</mt-tab-item>
        <mt-tab-item id="dangerCar_3">危险品</mt-tab-item>
      </mt-navbar>
      <mt-tab-container v-model="selected">
        <mt-tab-container-item id="taxi_2">
          <div
            v-show="isHasdata"
            class=""
          >
            <div v-if="!isLogin">
              <router-link to="/login">
                <img
                  src="../assets/imgs/toLoginIcon.png"
                  alt=""
                  class="toLoginIcon"
                >

                <img
                  src="../assets/imgs/nonLoginTxt.png"
                  alt=""
                  class="nonLoginTxt"
                >
              </router-link>
            </div>
            <div v-if="isLogin">
              <div
                class="trainItems"
                v-for="item in classlist"
                :key="item.index"
              >
                <div class="clearfix">
                  <div class="fl">
                    <div class="trainTit">
                      <img
                        src="../assets/imgs/huangg.png"
                        alt=""
                      >
                      {{item.title}}
                    </div>
                    <p>{{item.remark}}</p>
                    <p v-if="item.isPay === 1">学习进度：{{item.mPer}}%（{{item.mNotLearn}}/{{item.mBasicsLearn}}分钟）</p>
                    <div
                      class="hasBuy isBuy"
                      v-if="item.isPay === 1"
                    >
                      <img
                        src="../assets/imgs/sure.png"
                        alt=""
                      >
                      已购买<span>（有效期至{{item.expDate!=="" && item.expDate!==null?item.expDate:""}}）</span>
                    </div>
                    <div
                      class="nonBuy isBuy"
                      v-else
                    >
                      <img
                        src="../assets/imgs/money.png"
                        alt=""
                      >
                      {{item.money}}
                    </div>
                  </div>
                  <div class="fr">
                    <mt-button
                      v-if="item.isPay===1"
                      type="default"
                      class="trainBtn btnStudy"
                      @click="toCourseList(item.year)"
                    >去学习</mt-button>
                    <router-link
                      v-else
                      :to="{path:'/pay',query:{planId:item.id}}"
                      class="trainBtn btnStudy"
                    >去购买</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-show="!isHasdata"
            class="noData"
          >
            <img
              src="../assets/imgs/noDataIcon.png"
              alt=""
            >
            <p class="noDataTit">未查询到相关数据</p>
            <p>暂无数据，请刷新重试</p>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item id="goodsCar_1">
          <div
            v-show="isHasdata1"
            class=""
          >
            <div v-if="!isLogin">
              <router-link to="/login">
                <img
                  src="../assets/imgs/toLoginIcon.png"
                  alt=""
                  class="toLoginIcon"
                >

                <img
                  src="../assets/imgs/nonLoginTxt.png"
                  alt=""
                  class="nonLoginTxt"
                >
              </router-link>
            </div>
            <div v-if="isLogin">
              <div
                class="trainItems"
                v-for="item1 in classlist1"
                :key="item1.index"
              >
                <div class="clearfix">
                  <div class="fl">
                    <div class="trainTit">
                      <img
                        src="../assets/imgs/huangg.png"
                        alt=""
                      >
                      {{item1.title}}
                    </div>
                    <p>{{item1.remark}}</p>
                    <p v-if="item1.isPay === 1">学习进度：{{item1.mPer}}%（{{item1.mNotLearn}}/{{item1.mBasicsLearn}}分钟）</p>
                    <div
                      class="hasBuy isBuy"
                      v-if="item1.isPay === 1"
                    >
                      <img
                        src="../assets/imgs/sure.png"
                        alt=""
                      >
                      已购买<span>（有效期至{{item1.expDate!=="" && item1.expDate!==null?item1.expDate:""}}）</span>
                    </div>
                    <div
                      class="nonBuy isBuy"
                      v-else
                    >
                      <img
                        src="../assets/imgs/money.png"
                        alt=""
                      >
                      {{item1.money}}
                    </div>
                  </div>
                  <div class="fr">
                    <mt-button
                      v-if="item1.isPay===1"
                      type="default"
                      class="trainBtn btnStudy"
                      @click="toCourseList(item1.year)"
                    >去学习</mt-button>
                    <router-link
                      v-else
                      :to="{path:'/pay',query:{planId:item1.id}}"
                      class="trainBtn btnStudy"
                    >去购买</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-show="!isHasdata1"
            class="noData"
          >
            <img
              src="../assets/imgs/noDataIcon.png"
              alt=""
            >
            <p class="noDataTit">未查询到相关数据</p>
            <p>暂无数据，请刷新重试</p>
          </div>
        </mt-tab-container-item>
        <mt-tab-container-item id="dangerCar_3">
          <div
            v-show="isHasdata2"
            class=""
          >
            <div v-if="!isLogin">
              <router-link to="/login">
                <img
                  src="../assets/imgs/toLoginIcon.png"
                  alt=""
                  class="toLoginIcon"
                >

                <img
                  src="../assets/imgs/nonLoginTxt.png"
                  alt=""
                  class="nonLoginTxt"
                >
              </router-link>
            </div>
            <div v-if="isLogin">
              <div
                class="trainItems"
                v-for="item2 in classlist2"
                :key="item2.index"
              >
                <div class="clearfix">
                  <div class="fl">
                    <div class="trainTit">
                      <img
                        src="../assets/imgs/huangg.png"
                        alt=""
                      >
                      {{item2.title}}
                    </div>
                    <p>{{item2.remark}}</p>
                    <p v-if="item2.isPay === 1">学习进度：{{item2.mPer}}%（{{item2.mNotLearn}}/{{item2.mBasicsLearn}}分钟）</p>
                    <div
                      class="hasBuy isBuy"
                      v-if="item2.isPay === 1"
                    >
                      <img
                        src="../assets/imgs/sure.png"
                        alt=""
                      >
                      已购买<span>（有效期至{{item2.expDate!=="" && item2.expDate!==null?item2.expDate:""}}）</span>
                    </div>
                    <div
                      class="nonBuy isBuy"
                      v-else
                    >
                      <img
                        src="../assets/imgs/money.png"
                        alt=""
                      >
                      {{item2.money}}
                    </div>
                  </div>
                  <div class="fr">
                      <!-- 1出租车 2道路运输 3专项学习 4安全学习 5两类人员-->
                <img v-if="1===1" src="../assets/imgs/czcType.png" alt="" class="classType">
                <img v-else-if="2===2" src="../assets/imgs/dlysType.png" alt="" class="classType">
                <img v-else-if="3===3" src="../assets/imgs/zxxxType.png" alt="" class="classType">
                <img v-else-if="4===4" src="../assets/imgs/aqxxType.png" alt="" class="classType">
                <img v-else-if="5===5" src="../assets/imgs/llryType.png" alt="" class="classType">
                    <mt-button
                      v-if="item2.isPay===1"
                      type="default"
                      class="trainBtn btnStudy"
                      @click="toCourseList(item2.year)"
                    >去学习</mt-button>
                    <router-link
                      v-else
                      :to="{path:'/pay',query:{planId:item2.id}}"
                      class="trainBtn btnStudy"
                    >去购买</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-show="!isHasdata2"
            class="noData"
          >
            <img
              src="../assets/imgs/noDataIcon.png"
              alt=""
            >
            <p class="noDataTit">未查询到相关数据</p>
            <p>暂无数据，请刷新重试</p>
          </div>
        </mt-tab-container-item>

      </mt-tab-container>
    </div>
    <van-popup v-model="needwsBox" position="bottom">
<!-- 
ddddddddddddds
      dddddddddddd -->
    </van-popup>
  </div>
</template>
<style scoped>
.mint-navbar .mint-tab-item{
  margin :0 10%;
}
</style>
<script>
import { Toast, Indicator } from 'mint-ui'
import { getTrainlist } from '../../src/api/Api'
import { mapGetters } from 'vuex'
export default {
  name: 'RoadTransList',
  data () {
    return {
      classlist: [], // 客运
      classlist1: [], // 货运
      classlist2: [], // 危险品
      isLogin: false, // 是否登录
      isHasdata: true,
      isHasdata1: true,
      isHasdata2: true,
      selected: 'taxi_2',
      stuProgress: '0.00%',
      validHours: 0,
      basicHours: 0,
      dateEnd: '',
      payMoney: '0',
      needwsBox:false,
    }
  },
  computed: {
    ...mapGetters(['stuId', 'ProfessionId'])
  },
  watch: {
    selected (newval,oldval) {
      if (oldval !== newval) {
        var selVal = newval.split("_");
        this.getTrainlists(selVal[1])
      }
      console.log(newval,oldval)
    }
  },
  created () {
    var userId = sessionStorage.getItem('userId')
    if (userId === '' || userId === null || userId === undefined) {
      this.isLogin = false
    } else {
      this.isLogin = true
      this.getTrainlists('2')
    }
  },
  mounted () {
    window.myVue = this
  },
  methods: {
    getTrainlists (hyval) {
      var type = 2
      Indicator.open()
      var _this = this
      _this.isHasdata = true
      _this.isHasdata1 = true
      _this.isHasdata2 = true
      _this.classlist = []
      _this.classlist1 = []
      _this.classlist2 = []
      getTrainlist({
        source: type,
        type: hyval
      }).then(res => {
        if (res.data.returnCode === 1) {
          Indicator.close()
          if (hyval === '1') {
            _this.classlist1 = res.data.returnDate[0].tbStudyPlans
          } else if (hyval === '2') {
            _this.classlist = res.data.returnDate[0].tbStudyPlans
          } else if (hyval === '3') {
            _this.classlist2 = res.data.returnDate[0].tbStudyPlans
          }
          if (_this.classlist.length < 1) {
            _this.isHasdata = false
          } else {
            _this.isHasdata = true
          }
          if (_this.classlist1.length < 1) {
            _this.isHasdata1 = false
          } else {
            _this.isHasdata1 = true
          }
          if (_this.classlist2.length < 1) {
            _this.isHasdata2 = false
          } else {
            _this.isHasdata2 = true
          }
        } else {
          Indicator.close()
          _this.isHasdata = true
          _this.isHasdata1 = true
          _this.isHasdata2 = true
          _this.classlist = []
          _this.classlist1 = []
          _this.classlist2 = []
          Toast(res.data.returnMsg)
        }
      })
    },
    toCourseList (year) {
       Toast('缴费成功请在app上面进行学习')
      // if (
      //   sessionStorage.getItem('photo') === '' ||
      //   sessionStorage.getItem('photo') === null ||
      //   sessionStorage.getItem('photo') === undefined
      // ) {
      //   Toast('未上传头像，无法学习！')
      // } else {
      //   this.$router.push({ path: '/vGroup', query: { year: year } })
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/RoadTransList.vue